// Cash Report (Submit, Approval, Cash Report, Set up and their shared parts) — what was still written in English, in the
// portal's four languages (2026-10-21): the names a screen reader reads for each box of the three template forms. The
// screens' other words are `cash.`, `cashw.`, `cashf.`, `cashp.`, `cashm.`, `cashi.`, `cashq.`, `cashr.`, `cashc.` in
// i18n.js. The English stays word for word what the boxes were called before (scripts/check_cash_reports.py finds the
// Template 1 boxes by it). Account ids, week codes and "Field 4" are codes and stay as they are.
const en = {
  aria: {
    opening: '{{id}} opening',
    closing: '{{id}} closing balance',
    inflow: '{{id}} inflow',
    outflow: '{{id}} outflow',
    noTxn: '{{id}} no transaction',
    restricted: '{{id}} restricted',
    fixedDeposit: '{{id}} fixed deposit',
    internalInflow: '{{id}} internal inflow',
    internalOutflow: '{{id}} internal outflow',
    f4Account: 'Field 4 row {{n}} account',
    f4Entity: 'Field 4 row {{n}} entity',
    f4Inflow: 'Field 4 row {{n}} inflow',
    f4Outflow: 'Field 4 row {{n}} outflow',
    spendCategory: 'spend {{n}} category',
    spendMemo: 'spend {{n}} memo',
    spendAmount: 'spend {{n}} amount',
    payableCategory: 'payable {{n}} category',
    payableMemo: 'payable {{n}} memo',
    payableAmount: 'payable {{n}} amount',
    openingCash: 'opening cash',
    planInflow: '{{week}} plan inflow',
    planOutflow: '{{week}} plan outflow',
    comment: '{{week}} comment',
    monthEnd: '{{id}} month-end',
    weekEnd: '{{id}} week-end',
    netInflow: '{{id}} net inflow',
    netOutflow: '{{id}} net outflow',
    actions: 'actions',
  },
};

const ko = {
  aria: {
    opening: '{{id}} 기초',
    closing: '{{id}} 기말 잔액',
    inflow: '{{id}} 입금',
    outflow: '{{id}} 출금',
    noTxn: '{{id}} 거래 없음',
    restricted: '{{id}} 사용 제한',
    fixedDeposit: '{{id}} 정기예금',
    internalInflow: '{{id}} 법인 내 입금',
    internalOutflow: '{{id}} 법인 내 출금',
    f4Account: 'Field 4 {{n}}행 계좌',
    f4Entity: 'Field 4 {{n}}행 법인',
    f4Inflow: 'Field 4 {{n}}행 입금',
    f4Outflow: 'Field 4 {{n}}행 출금',
    spendCategory: '주요 지출 {{n}} 카테고리',
    spendMemo: '주요 지출 {{n}} 메모',
    spendAmount: '주요 지출 {{n}} 금액',
    payableCategory: '지급 예정 {{n}} 카테고리',
    payableMemo: '지급 예정 {{n}} 메모',
    payableAmount: '지급 예정 {{n}} 금액',
    openingCash: '기초 현금',
    planInflow: '{{week}} 계획 입금',
    planOutflow: '{{week}} 계획 출금',
    comment: '{{week}} 코멘트',
    monthEnd: '{{id}} 월말 잔액',
    weekEnd: '{{id}} 주말 잔액',
    netInflow: '{{id}} 상계 입금',
    netOutflow: '{{id}} 상계 출금',
    actions: '작업',
  },
};

const vi = {
  aria: {
    opening: '{{id}} đầu kỳ',
    closing: '{{id}} số dư cuối kỳ',
    inflow: '{{id}} tiền vào',
    outflow: '{{id}} tiền ra',
    noTxn: '{{id}} không có giao dịch',
    restricted: '{{id}} bị hạn chế',
    fixedDeposit: '{{id}} tiền gửi có kỳ hạn',
    internalInflow: '{{id}} tiền vào nội bộ',
    internalOutflow: '{{id}} tiền ra nội bộ',
    f4Account: 'Field 4 dòng {{n}} tài khoản',
    f4Entity: 'Field 4 dòng {{n}} pháp nhân',
    f4Inflow: 'Field 4 dòng {{n}} tiền vào',
    f4Outflow: 'Field 4 dòng {{n}} tiền ra',
    spendCategory: 'khoản chi {{n}} danh mục',
    spendMemo: 'khoản chi {{n}} ghi chú',
    spendAmount: 'khoản chi {{n}} số tiền',
    payableCategory: 'khoản phải trả {{n}} danh mục',
    payableMemo: 'khoản phải trả {{n}} ghi chú',
    payableAmount: 'khoản phải trả {{n}} số tiền',
    openingCash: 'tiền mặt đầu kỳ',
    planInflow: '{{week}} tiền vào kế hoạch',
    planOutflow: '{{week}} tiền ra kế hoạch',
    comment: '{{week}} bình luận',
    monthEnd: '{{id}} số dư cuối tháng',
    weekEnd: '{{id}} số dư cuối tuần',
    netInflow: '{{id}} tiền vào bù trừ',
    netOutflow: '{{id}} tiền ra bù trừ',
    actions: 'Thao tác',
  },
};

const zh = {
  aria: {
    opening: '{{id}} 期初',
    closing: '{{id}} 期末余额',
    inflow: '{{id}} 流入',
    outflow: '{{id}} 流出',
    noTxn: '{{id}} 无交易',
    restricted: '{{id}} 受限',
    fixedDeposit: '{{id}} 定期存款',
    internalInflow: '{{id}} 内部流入',
    internalOutflow: '{{id}} 内部流出',
    f4Account: 'Field 4 第 {{n}} 行 账户',
    f4Entity: 'Field 4 第 {{n}} 行 法人实体',
    f4Inflow: 'Field 4 第 {{n}} 行 流入',
    f4Outflow: 'Field 4 第 {{n}} 行 流出',
    spendCategory: '主要支出 {{n}} 类别',
    spendMemo: '主要支出 {{n}} 备注',
    spendAmount: '主要支出 {{n}} 金额',
    payableCategory: '应付款 {{n}} 类别',
    payableMemo: '应付款 {{n}} 备注',
    payableAmount: '应付款 {{n}} 金额',
    openingCash: '期初现金',
    planInflow: '{{week}} 计划流入',
    planOutflow: '{{week}} 计划流出',
    comment: '{{week}} 评论',
    monthEnd: '{{id}} 月末余额',
    weekEnd: '{{id}} 周末余额',
    netInflow: '{{id}} 抵销流入',
    netOutflow: '{{id}} 抵销流出',
    actions: '操作',
  },
};

const dictionary = { ns: 'xCash', en, ko, vi, zh };

export default dictionary;
